<template>
  <c-leaf class="product" tag="article">
    <header class="product-header">
      <slot name="title" />
    </header>

    <b-row tag="section">
      <b-col :[$root.mobile.up.key]="5">
        <c-carousel
                    class="product-images"
                    :autoplay="false">
          <slot name="images">
            <c-placeholder-image ratio="4x3" size="75" />
          </slot>
        </c-carousel>
      </b-col>

      <b-col :[$root.mobile.up.key]="7" class="product-container-right d-flex flex-column justify-content-end">
        <div class="product-description">
          <slot name="description" />
        </div>

        <div class="product-tags">
          <slot name="tags" />
        </div>

        <div class="product-price">
          <slot name="price-and-cart" />
        </div>
      </b-col>
    </b-row>

    <slot />
  </c-leaf>
</template>

<script>
import { PRODUCT_ORDER_STATUS } from '@/constants';

export default {
  name: 'Product',
  props: {
    productId: {
      type: String,
      default: ''
    },
    priceinfo: {
      type: Object,
      default: () => ({
        currency: 'CHF',
        price: 0,
        priceUnassembled: 0,
        priceOriginal: 0
      })
    },
    quantity: {
      type: Number,
      default: 1
    },
    quantityinfo: {
      type: Object,
      default: () => ({})
    },
    quantityPostFixSingular: {
      type: String,
      default: ''
    },
    quantityPostFixPlural: {
      type: String,
      default: ''
    },
    requiredAdditionalPropertiesValidation: {
      type: Object,
      default: () => ({})
    },
    errorToastTitle: {
      type: String,
      default: ''
    },
    orderStatus: {
      type: String,
      default: PRODUCT_ORDER_STATUS.AVAILABLE,
      validator: value => Object.values(PRODUCT_ORDER_STATUS).includes(value)
    },
    hideVatInfo: {
      type: Boolean,
      default: false
    },
    inherit: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
$product-header-margin-bottom: $spacer !default;

$product-images-max-width: none !default;
$product-images-img-padding-y: $component-padding-x / 4 * 3 !default;
$product-images-img-padding-x: $component-padding-x !default;
$product-images-placeholder-size: 80% !default;
$product-images-placeholder-color: $gray-300 !default;

$product-tags-gap: $spacer * 0.3 !default;

$product-mobile-breakpoint: $mobile-breakpoint !default;

$product-images-mobile-max-width: 320px !default;

.product {
  .product-header {
    margin-bottom: $product-header-margin-bottom;

    * {
      margin: 0;
    }
  }

  .product-container-right {
    gap: $spacer;
  }

  .product-images {
    margin: 0 auto;
    max-width: $product-images-max-width;

    img {
      margin: 0;
      padding: $product-images-img-padding-y $product-images-img-padding-x;
    }

    .image-placeholder {
      width: auto;
      height: $product-images-placeholder-size;
      color: $product-images-placeholder-color;
    }
  }

  .product-description {
    position: relative;
    // min-height: 100%;

    > .product-basketbutton {
      width: 100%;
      position: absolute;
      bottom: 0;
    }
  }

  .product-tags {
    display: flex;
    flex-wrap: wrap;
    margin: $product-tags-gap * -0.5;

    .badge {
      margin: $product-tags-gap * 0.5;
    }
  }

  @include media-breakpoint-down($product-mobile-breakpoint) {
    .product-images {
      max-width: $product-images-mobile-max-width;
    }

    .product-description {
      > .product-basketbutton {
        position: relative;
      }
    }
  }

  /* Linked marketing products on PDP: compact basket (search-result row pattern) */
  .marketing-products-on-pdp {
    display: flex;
    flex-direction: column;
    gap: $spacer * 0.5;

    .action-cell {
      width: auto;
      white-space: nowrap;
    }

    .purchase-basket-select {
      overflow: visible;
    }

    /* small basketbutton fixes quantity to 2.5rem — Einheit labels need room */
    .purchase-basket-select .basketbutton.small .basketbutton-quantity {
      width: auto;
      min-width: 2.5rem;
      max-width: 12rem;
    }

    .purchase-basket-select .basketbutton.small .basketbutton-quantity .dropdown {
      width: 100%;
    }

    .purchase-basket-select .basketbutton.small .basketbutton-quantity .dropdown-toggle {
      max-width: 12rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.2;
      text-align: left;
    }

    .purchase-basket-select .basketbutton-text {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding-left: $spacer * 0.35;
      padding-right: $spacer * 0.35;
    }

    .purchase-basket-select .basketbutton-text .bi {
      font-size: 1rem;
    }

    .purchase-basket-select .dropdown-toggle {
      min-height: 1.55rem;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>
